import React, { useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../Backend';
import { Button, Upload } from 'antd';
import { UploadOutlined, CheckCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

function UploadArchivo({ alumno, onUploadSuccess }) {
  const [uploading, setUploading] = useState(false);
  const [notification, setNotification] = useState(null);

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification(null);
    }, 4000);
  };

  const props = {
    beforeUpload: (file) => {
      if (file.type !== 'application/pdf') {
        showNotification('error', 'Solo se permiten archivos PDF.');
        return Upload.LIST_IGNORE;
      }

      const formData = new FormData();
      formData.append('archivo', file);
      formData.append('nombre_carrera', alumno.nombre_carrera);
      formData.append('cuatrimestre_grupo', alumno.cuatrimestre_grupo);
      formData.append('nombre_completo', alumno.nombre_alumno);
      formData.append('matricula', alumno.matricula);

      setUploading(true);

      axios.post(`${BACKEND_URL}/subirArchivo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then((res) => {
          showNotification('success', res.data.message || '¡Archivo subido correctamente!');
            if (onUploadSuccess) onUploadSuccess();

        })
        .catch((err) => {
          if (err.response?.data?.message) {
            showNotification('warning', err.response.data.message);
          } else {
            showNotification('error', 'Error al subir el archivo.');
          }
        })
        .finally(() => {
          setUploading(false);
        });

      return false;
    },
    showUploadList: false,
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
      case 'warning':
        return <ExclamationCircleOutlined style={{ color: '#faad14' }} />;
      case 'error':
        return <CloseCircleOutlined style={{ color: '#f5222d' }} />;
      default:
        return null;
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'success':
        return '#f6ffed';
      case 'warning':
        return '#fffbe6';
      case 'error':
        return '#fff2f0';
      default:
        return '#fff';
    }
  };

  const getBorderColor = (type) => {
    switch (type) {
      case 'success':
        return '#b7eb8f';
      case 'warning':
        return '#ffe58f';
      case 'error':
        return '#ffccc7';
      default:
        return '#d9d9d9';
    }
  };

  return (
    <>
      <Upload {...props}>
        <Button icon={<UploadOutlined />} loading={uploading}>
          Subir PDF
        </Button>
      </Upload>

      {/* Notificación personalizada */}
      {notification && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: getNotificationColor(notification.type),
            border: `1px solid ${getBorderColor(notification.type)}`,
            borderRadius: '8px',
            padding: '16px 20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            zIndex: 1000,
            minWidth: '300px',
            maxWidth: '400px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            animation: 'slideInRight 0.3s ease-out',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}
        >
          {getNotificationIcon(notification.type)}
          <div style={{ flex: 1 }}>
            <div style={{ 
              fontWeight: '600', 
              marginBottom: '4px',
              color: notification.type === 'success' ? '#389e0d' : 
                     notification.type === 'warning' ? '#d48806' : '#cf1322'
            }}>
              {notification.type === 'success' ? 'Éxito' : 
               notification.type === 'warning' ? 'Advertencia' : 'Error'}
            </div>
            <div style={{ color: '#666', fontSize: '14px' }}>
              {notification.message}
            </div>
          </div>
          <Button
            type="text"
            size="small"
            onClick={() => setNotification(null)}
            style={{ color: '#999' }}
          >
            ×
          </Button>
        </div>
      )}

      {/* CSS para la animación */}
      <style>{`
        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(100%);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </>
  );
}

export default UploadArchivo;